import { jsx as _jsx } from "react/jsx-runtime";
export const Cell = (props)=>{
    const { value, classes, onClick } = props;
    const _classes = `${classes} cell`;
    return /*#__PURE__*/ _jsx("div", {
        className: _classes,
        onClick: onClick,
        children: value
    });
};
export default Cell;
